import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import CloseIcon from './icons/close'

const OverlayElement = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

const ContainerElement = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: fit-content;
  padding: 20px;
  max-height: 95vh;
  overflow-y: ${(props) => props.overflowY};
`

const TitleContainerElement = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
`

const TitleElement = styled.h3`
  font-size: 1.2rem !important;
  font-weight: 400 !important;
  margin: 0 !important;
`

const IconWrapperElement = styled.button`
  background: none;
  border: none;
  padding: 0;
  height: 2rem;

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

const getFocusableElements = (element) =>
  element.querySelectorAll(
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]'
  )

function Modal({
  children,
  title,
  onClose,
  closeOnEsc = false,
  overflowY = 'auto',
}) {
  const containerRef = useRef(null)

  // prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  // close modal when escape key is pressed
  useEffect(() => {
    if (!closeOnEsc) return

    const handleKeyDown = (event) => event.key === 'Escape' && onClose()
    document.addEventListener('keydown', handleKeyDown)

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [onClose, closeOnEsc])

  // prevent focusing elements outside of the modal
  const handleBlur = (e) => {
    const container = containerRef.current
    if (container.contains(e.relatedTarget)) return

    const focusableElements = getFocusableElements(container)
    if (focusableElements.length === 0) return

    focusableElements[0].focus()
  }

  return (
    <OverlayElement>
      <ContainerElement
        innerRef={containerRef}
        tabIndex={-1}
        onBlur={handleBlur}
        overflowY={overflowY}
      >
        <TitleContainerElement>
          {typeof title === 'string' ? (
            <TitleElement>{title}</TitleElement>
          ) : (
            title
          )}
          <IconWrapperElement onClick={onClose}>
            <CloseIcon />
          </IconWrapperElement>
        </TitleContainerElement>
        {children}
      </ContainerElement>
    </OverlayElement>
  )
}

export default Modal
